export { default } from './loadScript'
